

export const Field2Groups:any = {
    'text': {
        label   : 'Text',
        color   : 'blue'
    },
    'number': {
        label   : 'Numbers',
        color   : 'green'
    },
    'select': {
        label   : 'Select',
        color   : 'yellow'
    },
    'date_time' : {
        label   : 'Date & Time',
        color   : 'violet'
    },
    'bool'  : {
        label   : 'True/False',
        color   : 'coral'
    },
    'info'  : {
        label   : 'Info',
        color   : 'darkblue'
    },
    'misc' : {
        label   : 'Misc',
        color   : 'pink'
    },
    'estimate' : {
        label   : 'Estimate',
        color   : 'violet'
    }
}

export const GROUP_TEXT             = 'text'
export const GROUP_NUMBER           = 'number'
export const GROUP_SELECT           = 'select'
export const GROUP_DATE_TIME        = 'date_time'
export const GROUP_BOOL             = 'bool'
export const GROUP_INFO             = 'info'
export const GROUP_FINANCE          = 'finance'
export const GROUP_MISC             = 'misc'
export const GROUP_ESTIMATE         = 'estimate'

